import Base from './Base';
import SlackChannel from '../models/SlackChannel';

export default class SlackChannels extends Base {
    get models() {
        const collection = this.data.map(item => new SlackChannel(item));
        collection.collection = this;

        return collection;
    }
}
